import { initialState, DeclinedReasonsState, declinedReasonsAdapter } from './declined-reasons.interfaces';
import * as fromDeclinedReasons from './declined-reasons.actions';
import { ActionReducer, MetaReducer } from '@ngrx/store';

export function reducer(
  state: DeclinedReasonsState,
  action: fromDeclinedReasons.DeclinedReasonsAction
): DeclinedReasonsState {
  switch (action.type) {
    case fromDeclinedReasons.GET_DECLINED_REASONS_FROM_SERVER_SUCCESS: {
      return {
        ...declinedReasonsAdapter.addMany(action.payload.declinedReason, state)
      };
    }

    default: {
      return state;
    }
  }
}

export function declinedReasonsStateHydration(
  reducer: ActionReducer<DeclinedReasonsState>
): ActionReducer<DeclinedReasonsState> {
  return function(
    state: DeclinedReasonsState,
    action: any,
    metaReducer: string = 'stateHydration'
  ): DeclinedReasonsState {
    if (state === undefined) {
      console.log('populate declinedReasons state from local storage?');
      let declinedReasons: any = localStorage.getItem('declined-reasons-state');
      state = declinedReasons ? JSON.parse(declinedReasons) : initialState;
    }
    const newState = reducer(state, action);
    if (action.feature === 'labourOperations.serviceGroupRates' && action.triggerStorageSync) {
      localStorage.setItem('service-group-rates-state', JSON.stringify(newState));
    }

    return newState;
  };
}

export const metaReducers: MetaReducer<DeclinedReasonsState>[] = [declinedReasonsStateHydration];
